module.exports = __webpack_public_path__ + "img/history-2.3814b92d.png";